import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderSort, IFilter, Logic, Operator } from 'core-components/types'
import Logger from 'core/utils/Logger'

import { getJbpExtendedPartnerDataCrud } from './helpers/getJbpExtendedPartnerDataCrud'
import { mapEPRecordFromJBPMasterDealerExtendedPartnerView } from './mapping'

interface IFetchEPDataParams {
  partnerId?: string
  programType: ProgramTypes
}

export const fetchEPData = (
  { partnerId = '', programType }: IFetchEPDataParams,
  options?: ICrudFetchOptions
) => {
  const crud = getJbpExtendedPartnerDataCrud(options?.cacheKey)
  const filterByPartnerId: IFilter[] = partnerId
    ? [
        {
          field: 'MDPartnerId',
          operator: Operator.EQUAL,
          value: partnerId,
        },
        {
          field: 'EPPartnerId',
          operator: Operator.ISNOTNULL,
          value: '',
        },
      ]
    : []

  const filterByProgramType: IFilter[] = [
    {
      field: 'EPProgramType',
      operator: Operator.EQUAL,
      value: programType,
    },
  ]

  const filters = {
    logic: Logic.AND,
    filters: [...filterByPartnerId, ...filterByProgramType],
  }

  const sort: IDataProviderSort = {
    field: 'EntryId',
    dir: 'desc',
  }

  crud.setDefaultFilter(filters)
  crud.setSort(sort)
  crud.setPaging({
    page: 0,
    pageSize: 1000,
  })

  return crud
    .fetch({
      skipHierarchyFilter: options?.skipHierarchyFilter,
      force: options?.isForce,
      skipTotal: options?.skipTotal,
    })
    .then((result) => {
      if (result && result.items) {
        return result.items.map(mapEPRecordFromJBPMasterDealerExtendedPartnerView)
      }

      return []
    })
    .catch((e) => {
      Logger.error(e)
      return []
    })
}
